export function isVectorSignalWallboardUrl(src: string): boolean {
  try {
    const url = new URL(src.trim());
    return isVectorSignalWallboardLocation(url);
  } catch {
    return false;
  }
}

export function prepareVectorSignalWallboardWebpageUrl(src: string): string {
  const trimmed = src.trim();
  if (!trimmed) return '';

  try {
    const url = new URL(trimmed);
    if (
      isVectorSignalWallboardLocation(url) &&
      !url.searchParams.has('legacy') &&
      !url.searchParams.has('modern')
    ) {
      url.searchParams.set('modern', '1');
      return url.toString();
    }
  } catch {
    return trimmed;
  }

  return trimmed;
}

function isVectorSignalWallboardLocation(url: URL): boolean {
  return url.hostname === 'vectorsignal.app' && url.pathname.startsWith('/display/wallboard/');
}
